import { estimatedTimeRefDataSource } from '../state/estimated-time-datasource'

/**
 * Shared estimated-time-name reference data for select/combobox pickers. All
 * callers share one module-level cache (see `state/estimated-time-datasource.ts`).
 */
export function useSelectEstimatedTimeDataSource() {
  return {
    estimatedTimeNames: estimatedTimeRefDataSource.items,
    loadingEstimatedTimeNames: estimatedTimeRefDataSource.loading,
    fetchEstimatedTimeNames: estimatedTimeRefDataSource.fetch
  }
}
